// extracted by mini-css-extract-plugin
export var photoWrapper = "dish-of-the-day-section-module--photo-wrapper--Rmegf";
export var rectangleWrapper = "dish-of-the-day-section-module--rectangle-wrapper--blIEv";